import React from "react";

import { Link, useStaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import Breadcrumbs from "../components/Breadcrumbs";
import PageLayout from "../components/PageLayout";

import futterlexikonData from "../../content/data/futterlexikon.json";
import futterplanData from "../../content/data/futterplan.json";

export default function Apps() {
  const breadcrumbs = [{ label: "Apps" }];

  const apps = [futterlexikonData, futterplanData];

  const { allFile } = useStaticQuery(graphql`
    query {
      allFile(filter: { extension: { eq: "png" } }) {
        nodes {
          relativePath
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
      }
    }
  `);

  return (
    <PageLayout title="Apps">
      <main>
        <div>
          <Breadcrumbs crumbs={breadcrumbs} />
          <div className="row m-2">
            {apps.map((app, idx) => (
              <div key={idx} className="col-md-6">
                <article className="m-2 p-3">
                  <div className="row">
                    <div className="col-md-6">
                      <Link to={`/apps/${app.id}`}>
                        <GatsbyImage
                          image={getImage(
                            allFile.nodes.find(
                              ({ relativePath }) =>
                                relativePath === app.id + ".png",
                            ),
                          )}
                          alt={app.title}
                          placeholder="blurred"
                          height={300}
                          imgStyle={{ borderRadius: "50px" }}
                        />
                      </Link>
                    </div>
                    <div className="col-md-6">
                      <Link to={`/apps/${app.id}`}>
                        <h2>{app.title}</h2>
                      </Link>
                      <p>{app.description}</p>
                    </div>
                  </div>
                </article>
              </div>
            ))}
          </div>
        </div>
      </main>
    </PageLayout>
  );
}
